import React from 'react';
import {
    Input,
    Icon,
    Col, Row,
    Table,
    Pagination,
    Button,
    Form,
    Tooltip,
    Select,
    Modal,

} from 'antd';
const SelectOption=Select.Option;

const {Search} = Input;
import AsyncAppHOCFN  from '../AsyncAppHOC'
import {getLocale } from '../localintl';

const FormItem=Form.Item;
import style from './index.less'
import {getOptionsByDictionary,changeByDictionary} from '../utils/common';
const formItemLayout = {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 },
};
import IntlWrap from '../intlWrap'
class Currency extends React.Component {
    /**
     * 构造方法
     * @param props
     */
    static getDerivedStateFromProps(nextProps) {
        // Should be a controlled component.
        if ('value' in nextProps) {
            if(!nextProps.value){
                return {
                    value: '1',
                };
            }
            return {
                value:nextProps.value || '1',
            };
        }
        return null;
    }

    constructor(props) {
        super(props);
        const value = props.value ||'1';
        this.state={
            value,
            params:{

                companyId: localStorage.getItem('loginInfo')&&localStorage.getItem('loginInfo').company||'',
            },
            currency:[],
        }
    }



    /**
     * 组件渲染之后执行
     */
    componentDidMount() {
        this.dispatchRequet()
    }

    dispatchRequet=()=>{
        const {dispatch,getDate,locale} = this.props;
        getDate(
            {
                name:'getCurrencyDate',
                url:'http://192.168.3.80:10201/api/101110101',
                locale
            },()=>{

                let {getCurrencyDate}=this.props;
                console.log(getCurrencyDate,'getCurrencyDate')

                let rows=getCurrencyDate.posts&&getCurrencyDate.posts.rows||[];
                this.setState({
                    currency:rows
                });
            })
    }
    changeV=(v)=>{
        let {onChange}=this.props;
        if(onChange&&typeof onChange=="function"){
            onChange(v)
        }

    }
    onSearch=(val)=> {
        console.log('search:', val);
    }
    render(){
        let {currency,value}=this.state;

        let {disabled=false}=this.props;
        let selectedLang = getLocale();
        return(
            <Select disabled={disabled} value={(value-0)||1} onChange={this.changeV} showSearch onSearch={this.onSearch} filterOption={(input, option) =>
            {
                console.log(option.props,'props')
                let id=option.props.value+''
                return id.indexOf(input.toLowerCase())>=0||option.props.children[0].toLowerCase().indexOf(input.toLowerCase()) >= 0
                // return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }

            }>
                {currency.map(node=>{
                    const k = node.currencyId;
                    const t =selectedLang&&selectedLang=='en-US'? node.currencyEname:node.currencyName;
                    return <SelectOption value={k} key={k} >{t}--{k}</SelectOption>
                })}

            </Select>
        )
    }
}


export default IntlWrap(AsyncAppHOCFN(Currency));